/**
 * Запускает коллбек на каждое изменение URL
 * все же может работать нестабильно, так что только для некритичных кейсов
 * @throws {Error}
 */
export function createPathNameWatcher(callback: (watcherType: 'NavigationApi' | 'MutationObserver') => void) {
  type AddWatcherTypeFn = <T extends typeof callback>(fn: T, watcherType: Parameters<T>[0]) => () => void
  const addWatcherType: AddWatcherTypeFn = (fn, watcherType) => () => fn(watcherType)

  switch (true) {
    case withNavigationApi(addWatcherType(callback, 'NavigationApi')): {
      break
    }

    case withMutationObserver(addWatcherType(callback, 'MutationObserver')): {
      break
    }

    default: {
      throw new Error('Unable to setup navigation watcher')
    }
  }
}

function withMutationObserver(callback: () => void): boolean | undefined {
  try {
    if ('MutationObserver' in window) {
      let previousPathname = window.location.pathname

      const observer = new MutationObserver(() => {
        if (previousPathname !== window.location.pathname) {
          previousPathname = window.location.pathname
          callback()
        }
      })

      observer.observe(window.document, {subtree: true, childList: true})

      return true
    }
  } catch (error) {
    console.error(error)
  }
}

function withNavigationApi(callback: () => void): boolean | undefined {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentEntryId = (window as any).navigation?.currentEntry?.id

    if (currentEntryId != null) {
      const typedWindow = window as typeof window & {
        navigation: {
          addEventListener: (type: string, listener: () => void) => void
        }
      }

      typedWindow.navigation.addEventListener('navigate', callback)

      return true
    }
  } catch (error) {
    console.error(error)
  }
}
